"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_SRC = "/image/new-version/machining/cnc-milling/how-cnc-milling-works.webp";

export default function LeftTextRightImage() {
	const t = useTranslations("cncMillingHowItWorks");

	const title = t("title");
	const imageAlt = t("imageAlt");

	return (
		<section className="w-full bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-12 xl:gap-16">
					<div className="w-full lg:w-1/2">
						<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
							{title}
						</h2>
						<div className="space-y-6 text-sm leading-relaxed text-black md:text-base">
							<p>{t("paragraph1")}</p>
							<p>{t("paragraph2")}</p>
							<p>{t("paragraph3")}</p>
							<p>{t("paragraph4")}</p>
						</div>
					</div>
					<div className="w-full lg:sticky lg:top-24 lg:w-1/2">
						<div className="relative aspect-[4/3] w-full overflow-hidden">
							<Image
								src={IMAGE_SRC}
								alt={imageAlt}
								fill
								className="object-cover"
								sizes="(max-width: 1024px) 100vw, 50vw"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
